// extracted by mini-css-extract-plugin
module.exports = {"PriceTabSwitcher":"PriceTabSwitcher-module--PriceTabSwitcher--2i-yQ","switch":"PriceTabSwitcher-module--switch--miC3_","active":"PriceTabSwitcher-module--active--2fgeg"};